<script setup lang="ts">
    import type { SelectableTab } from '~/components/shared/SelectableTabButtons.vue';
    import { AcademyTrainingsListingTab } from '~/types/academy/trainings-listing-tab';

    const { disabled = false } = defineProps<{
        disabled?: boolean;
    }>();

    const emit = defineEmits<{
        'toggle-filter': [];
        'reset-filters': [];
    }>();

    const { t } = useI18n();

    const { tab } = useAcademyTrainingsListing();

    const trainingTabs = computed<SelectableTab<AcademyTrainingsListingTab>[]>(() => [
        { key: AcademyTrainingsListingTab.All, label: t('academy.trainings.tabs.all') },
        { key: AcademyTrainingsListingTab.Open, label: t('academy.trainings.tabs.open') },
        { key: AcademyTrainingsListingTab.Completed, label: t('academy.trainings.tabs.completed') }
    ]);
</script>

<template>
    <div class="toolbar">
        <PrimaryButton
            :button-text="$t('academy.listing.filter')"
            product-button
            has-icon
            ghost
            variant="secondary"
            class="filter-btn"
            :disabled="disabled"
            @click="!disabled && emit('toggle-filter')"
        >
            <template #customIcon>
                <Icon
                    name="lucide:filter"
                    mode="svg"
                />
            </template>
        </PrimaryButton>

        <div class="course-status-tabs-wrapper">
            <SelectableTabButtons
                v-model="tab"
                :tabs="trainingTabs"
                :aria-label="$t('academy.trainings.tabs.ariaLabel')"
                class="course-status-tabs"
                :disabled="disabled"
            />

            <AcademyTrainingsListingSortSelect />
        </div>
        <SharedTextIconButton
            class="reset-filters-btn"
            stretch
            :label="$t('academy.listing.resetFilters')"
            @click="$emit('reset-filters')"
        />
    </div>
</template>

<style lang="scss" scoped>
    .toolbar {
        display: flex;
        flex-direction: column;
        gap: var(--spacing);
        background-color: var(--brand-primary-10);
        padding: var(--spacing);
        border-radius: var(--border-radius-s);
        margin-bottom: var(--spacing--2);

        @media (min-width: $br-l) {
            background-color: transparent;
            padding: 0;
            border-radius: 0;
        }

        .filter-btn {
            width: 100%;
            justify-content: space-between;
            background-color: var(--white);
            color: var(--black);

            @media (min-width: $br-l) {
                display: none;
            }
        }

        .reset-filters-btn {
            @media (min-width: $br-l) {
                display: none;
            }
        }

        .course-status-tabs-wrapper {
            display: flex;
            flex-direction: column;
            gap: var(--spacing--2);

            @media (min-width: $br-l) {
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
            }
        }
    }
</style>
